export default __webpack_public_path__ + "static/media/english-to-norwegian-screenshot-05.9f672e22.png";